import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

const apolloClient = new ApolloClient({
  link: new HttpLink({ uri: '/graphql' }), // Use the relative path for the proxy
  cache: new InMemoryCache(),
});

export default apolloClient;
